/**
 * @fileoverview Prompt template for world-place-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating memorable and significant places for fiction.

## TASK INSTRUCTIONS:
Your task is to analyze the provided story context and generate ideas for significant places that could appear in the story world.

{{#if targetElement}}
**IMPORTANT: Generate ONLY {{targetElement}}s. Do not generate any other element type.**
{{/if}}

1. Review the existing world places to avoid duplicates.
2. Based on the story context, generate a list of *new* places that would add value to the story.
{{#if targetElement}}
{{#eq targetElement "location"}}
   - Focus exclusively on **Locations**: Geographic areas, regions, territories, or named areas of significance (e.g., The Widow's Maw, Forest of Whispers, The Undercity, Downtown Seattle).
{{/eq}}
{{#eq targetElement "building"}}
   - Focus exclusively on **Buildings**: Significant structures, landmarks, or monuments (e.g., Castle Blackmoor, The Great Library, The Empire State Building, ancient temples).
{{/eq}}
{{else}}
   - **Locations**: Geographic areas, regions, territories, or named areas of significance (e.g., The Widow's Maw, Forest of Whispers, The Undercity).
   - **Buildings**: Significant structures, landmarks, or monuments (e.g., Castle Blackmoor, The Great Library, ancient temples).
{{/if}}
3. Prioritize places that:
   - Are critical to the plot or character development
   - Have rich histories or atmospheric qualities
   - Could serve as settings for important scenes
   - Reflect the world's culture, geography, or social structure
4. Compare ideated places with existing ones. Only return places that don't exist yet.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

## SECONDARY TASK CONTEXT

<<<worldPlaces>>>

<<<worldElements>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
For each place, you MUST provide:
- **name**: A distinctive name for the place
{{#if targetElement}}
- **element**: Must be "{{targetElement}}" for all places (as specified in the task instructions)
{{else}}
- **element**: Either "location" (geographic area/region) or "building" (structure/landmark)
{{/if}}
- **initialDescription**: A compelling description covering what the place is, its significance, and why it matters to the story

Provide your output in the required JSON format.
`;
